import React from 'react'
import { AudioContext } from './AudioContext'
import styles from './AudioPlayer.module.css'

const PlayerSubtitle = props => (
  <AudioContext.Consumer>
    {player => player.currentText ? (
      <div className={`audioplayer-subtitle-el ${styles.subtitle}`}>
        {player.currentText.split('\n').map((part, idx) => (
          <p key={idx}><span dangerouslySetInnerHTML={{ __html: part }} /></p>
        ))}
      </div>
    ) : null}
  </AudioContext.Consumer>
)

export default PlayerSubtitle
